import { List, P, Strong } from '@ahmdigital/ui';
import React from 'react';

import { featuresWithAccidentOverride } from './shared';

export default {
  intro: {
    description: (
      <>
        <P>
          For those who don’t need the bells and whistles and just like to keep things simple, and with no excess for
          dependants too - nice.
        </P>
        <Strong>Inclusions</Strong>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Sleep studies</Strong>
          </li>
          <li>
            <Strong>Joint reconstructions</Strong>
          </li>
          <li>
            <Strong>Dental surgery</Strong>
          </li>
          <li>
            <Strong>Hernia & appendix</Strong>
          </li>
          <li>
            <Strong>Tonsils, adenoids and grommets</Strong>
          </li>
          <li>
            <Strong>Miscarriage and termination of pregnancy</Strong>
          </li>
        </List>
        {featuresWithAccidentOverride.features}
      </>
    ),
    disclaimer: featuresWithAccidentOverride.disclaimers,
  },
};
